import Vue from 'vue'
// CSS import
import 'chartist/dist/chartist.min.css'

Vue.use(requireChartist())
function requireChartist() {
  return require('vue-chartist')
}

